module.exports = __webpack_public_path__ + "static/Grimlock-71d221d5c202fcfdabf46a15d0ab62c4.jpg";